import { MODULE } from "./statusFilter.actionTypes";

export const isFetchingStatuses = (state) => state.getIn([MODULE, "isFetchingStatuses"]);

export const getStatuses = (state) => state.getIn([MODULE, "statuses"]);

export const getSelectedStatuses = (state) => state.getIn([MODULE, "selectedStatuses"]);
